import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

class NavigationInner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        const navigation = content.map((item, index) => (
            <li key={index}>
                <a href={item.url} target="_blank" rel="nofollow me noopener noreferrer" title={item.title}>
                    {item.title}
                </a>
            </li>
        ));

        return <ul className="clearfix">{navigation}</ul>;
    }
}

/**
 * 定义 Navigation 组件
 */
class Navigation extends React.PureComponent {
    render() {
        const { content } = this.props;

        return (
            <div className={styles.navBg}>
                <div className={styles.navCon}>
                    <Chip id="50163" type="struct" title="导航" groupName="头部" content={content}>
                        <NavigationInner />
                    </Chip>
                </div>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
Navigation.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
Navigation.defaultProps = {};

export default errorBoundary(Navigation);
